// eslint-disable-next-line import/no-anonymous-default-export
export default {
	API_URL: 'https://sb-api.tinymart.in',
	FIREBASE_CONFIG: {
		apiKey: 'AIzaSyC9MVTvum8V65o1puXrj8JQAQHU0bX50T0',
		authDomain: 'tinymart-go-webapp.firebaseapp.com',
		databaseURL: 'https://tinymart-go-webapp.firebaseio.com',
		projectId: 'tinymart-go-webapp',
		storageBucket: 'tinymart-go-webapp.appspot.com',
		messagingSenderId: '281687523958',
		appId: '1:281687523958:web:a24ebaa3cc08530d8a1557',
		measurementId: 'G-PHRBGZ3LRE',
	},
	// when changing here alse please also change it scrips/staging/release
	RELEASE_VER: 'v2.5.100-rc1',
	logApiURL: 'http://t-pwa.tinymart.in/client/logger',
	guest_mode: true,
	anchorDummyData: [],
};
